import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export const TWO_DECIMAL_DIGITS = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};
export const OPTIONAL_DECIMAL_DIGITS = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
};
export function formatDollars(amount, options = {}) {
    if (amount === undefined) {
        return '';
    }
    if (typeof amount === 'string') {
        return `$${amount}`;
    }
    return Intl.NumberFormat('en-US', _object_spread({
        style: 'currency',
        currency: 'USD',
        useGrouping: false
    }, options)).format(amount);
}
export function formatDollarsWithOptionalCents(amount) {
    return formatDollars(amount, OPTIONAL_DECIMAL_DIGITS);
}
